import { TDeviceType } from '@cian/ui-kit';

export const prevQuestionTexts: { [key in TDeviceType]: string } = {
  desktop: 'Предыдущий вопрос',
  phone: 'Назад',
  tablet: 'Назад',
};
